const ATTRS = {
  VARIANT_ID: 'data-variant-id',
  PRODUCT_HANDLE: 'data-product-handle',
};

function replaceElement(newElement, currentElement) {
  if (currentElement && newElement) {
    currentElement.replaceWith(newElement);
    return true;
  }
  return false;
}

function refreshProductElements(tempDiv, productFormEl) {
  const newProductForm = tempDiv.querySelector('product-form');
  if (!newProductForm) return false;

  const elementsToReplace = [
    {
      newSelector: '.product__price',
      newContext: tempDiv,
      currentSelector: '.product__price',
      currentContext: productFormEl
    },
    {
      newSelector: 'product-variant',
      newContext: newProductForm,
      currentSelector: 'product-variant',
      currentContext: productFormEl
    },
    {
      newSelector: 'quantity-selector',
      newContext: newProductForm,
      currentSelector: 'quantity-selector',
      currentContext: productFormEl
    }
  ];

  elementsToReplace.forEach(({ newSelector, newContext, currentSelector, currentContext }) => {
    replaceElement(
      newContext.querySelector(newSelector),
      currentContext.querySelector(currentSelector)
    );
  });

  const newSubmitButton = newProductForm.querySelector('button[type="submit"]');
  const currentSubmitButton = productFormEl.querySelector('form[data-product-form] button[type="submit"]');
  if (replaceElement(newSubmitButton, currentSubmitButton)) {
    if (newSubmitButton) {
      newSubmitButton.classList.remove('product-atc__button--loading');
      if (productFormEl.submitButton) {
        productFormEl.submitButton = newSubmitButton;
      }
    }
  }

  const newVariantInput = newProductForm.querySelector('form[data-product-form] input[name="id"]');
  const currentVariantInput = productFormEl.querySelector('form[data-product-form] input[name="id"]');
  if (currentVariantInput && newVariantInput) {
    currentVariantInput.value = newVariantInput.value;
  }

  return true;
}

class ProductVariant extends HTMLElement {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
  }

  connectedCallback() {
    this.querySelectorAll('input[type="radio"]').forEach(input => {
      input.addEventListener('change', this.handleChange);
    });
  }

  disconnectedCallback() {
    this.querySelectorAll('input[type="radio"]').forEach(input => {
      input.removeEventListener('change', this.handleChange);
    });
  }

  handleChange(event) {
    const inputEl = event.target;
    if (!inputEl || inputEl.type !== 'radio') return;

    const variantId = inputEl.getAttribute(ATTRS.VARIANT_ID);
    if (!variantId) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId.toString());
    window.history.replaceState({}, '', url.toString());

    const productFormEl = this.closest('product-form');
    if (!productFormEl) return;

    this.updateVariantInput(variantId);
    this.refreshProductForm(productFormEl);
  }

  updateVariantInput(variantId) {
    const form = this.closest('form[data-product-form]');
    if (!form) return;

    let input = form.querySelector('input[name="id"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      form.appendChild(input);
    }
    input.value = variantId;
  }

  async refreshProductForm(productFormEl) {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', 'product');
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error('Failed to fetch product section');

      const html = await response.text();
      if (!html) return;

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      refreshProductElements(tempDiv, productFormEl);
    } catch (error) {
      console.error('Failed to refresh product form:', error);
    }
  }

}

if (!customElements.get('product-variant')) {
  customElements.define('product-variant', ProductVariant);
}
